import { useTheme } from "@mui/material";
import DSBox from "views/system-design/DSBox";
import DSTypography from "views/system-design/DSTypography";
import CountBadge from "./CountBadge";
import DSPrimaryButton from "views/system-design/DSPrimaryButton";

interface GroupedError {
  errorSignature: string;
  originalMessage: string;
  count: number;
  deviceCounts: Record<string, number>;
  deviceIds: string[];
  firstOccurrence: string;
  lastOccurrence: string;
  versions: number[];
  severity: "ERROR" | "WARNING";
}

const ErrorCard = ({
  error,
  index,
  onOpenLogs,
}: {
  error: GroupedError;
  index: number;
  onOpenLogs: (error: GroupedError) => void;
}) => {
  const { palette } = useTheme();
  const truncatedMessage =
    error.errorSignature.length > 60
      ? error.errorSignature.slice(0, 60) + "..."
      : error.errorSignature;

  return (
    <DSBox
      sx={{
        border: "1px solid",
        borderColor: palette.divider,
        borderRadius: 2,
        bgcolor: palette.background.paper,
        transition: "all 0.2s",
        "&:hover": {
          boxShadow: 2,
          borderColor: palette.action.disabled,
        },
        boxShadow: 0,
      }}
    >
      <DSBox sx={{ p: 2 }}>
        <DSBox
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
          }}
        >
          <DSTypography sx={{ fontSize: 12, color: palette.text.secondary }}>
            #{index + 1}
          </DSTypography>
          <CountBadge count={error.count} severity={error.severity} />
        </DSBox>

        <DSTypography
          sx={{
            fontSize: 12,
            fontFamily: "monospace",
            color: palette.text.primary,
            wordBreak: "break-word",
            mb: 1.5,
          }}
        >
          {truncatedMessage}
        </DSTypography>

        <DSBox
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
            fontSize: 11,
            color: palette.text.secondary,
          }}
        >
          <span>Devices: {error.deviceIds.length}</span>
          <DSPrimaryButton
            size="small"
            variant="outlined"
            onClick={(e) => {
              e.stopPropagation();
              onOpenLogs(error);
            }}
            sx={{ py: 0.5, px: 1 }}
          >
            Open Logs Table
          </DSPrimaryButton>
        </DSBox>
      </DSBox>
    </DSBox>
  );
};

export default ErrorCard;
